import { Button, styled, Typography } from '@mui/material';
import { getQueryKey } from '@trpc/react-query';
import { Row } from 'further-ui/components/Layout';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';

const SkipButton = styled(Button)(({ theme }) => ({
  padding: 0,
  color: theme.palette.grey[600],
  textDecoration: 'underline',
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
}));

type Props = {
  investorId: string;
  vehicleId: string;
  useCoolOff: boolean;
};

const CoolOffResult: React.FC<Props> = ({
  useCoolOff,
  investorId,
  vehicleId,
}) => {
  const [coolOffResult] = api.lpInvestmentCoolOff.get.useSuspenseQuery({
    investorId,
    vehicleId,
  });

  const { isPending, mutate: skipCoolOff } =
    api.lpInvestmentCoolOff.skip.useMutation(
      useHandleTrpcMutation()({
        successMessage: '24-hour cool off skipped successfully.',
        invalidations: [
          getQueryKey(api.lpInvestmentCoolOff.get, {
            vehicleId,
            investorId,
          }),
        ],
      }),
    );

  const handleSkipCoolOff = () => {
    skipCoolOff({ investorId, vehicleId });
  };

  if (!useCoolOff) {
    return (
      <Typography variant="body2" color="grey.600">
        Not required
      </Typography>
    );
  }

  if (!coolOffResult) {
    return (
      <Typography variant="body2" color="grey.600">
        --
      </Typography>
    );
  }

  if (coolOffResult.isElapsed) {
    return (
      <Typography variant="body2" color="grey.600">
        Complete -{' '}
        {coolOffResult.elapsesAfter.toLabel(undefined, 'dd/MM/yyyy HH:mm')}
      </Typography>
    );
  }

  return (
    <Row centered spacing="xs">
      <Typography variant="body2" color="grey.600">
        Pending until -{' '}
        {coolOffResult.elapsesAfter.toLabel(undefined, 'dd/MM/yyyy HH:mm')}
      </Typography>
      <SkipButton
        variant="text"
        onClick={handleSkipCoolOff}
        disabled={isPending}
      >
        Skip cool off
      </SkipButton>
    </Row>
  );
};

export default CoolOffResult;
